export interface CalendarEvent {
  id: string;
  title: string;
  startDate: Date;
  endDate: Date;
  timeZone: string | null;
  styles: Record<string, string>;
  originalStartDate?: Date;
  originalEndDate?: Date;
  partial?: 'start' | 'mid' | 'end';
}

export interface CalendarConfig {
  oneHourHeight: number;
  defaultDayViewColumnWidthPx: number;
  minDayViewColumnWidthPx: number;
  maxVisibleCalendars: number;
}

export interface Calendar {
  id: string | null;
  name: string | null;
  timeZone: string | null;
  events: {
    [year: number]: {
      [month: number]: {
        [date: number]: CalendarEvent[];
      };
    };
  };
}

export interface CalendarDataSource {
  id: string;
  title: string;
  start: Date;
  end: Date;
  styles: Record<string, string>;
  calendarId: string | null;
  calendarName: string;
  calendarTimeZone: string | null;
}

export enum CalendarView {
  Day = 'day',
  ThreeDay = '3day',
  Week = 'week',
  Month = 'month',
}

export enum CalendarTimeFormat {
  '12H' = 12,
  '24H' = 24,
}

export enum CalendarTimeScale {
  '1H' = 60,
  '30MIN' = 30,
}

export enum CalendarDateFormat {
  ShortDateUS = 'MM/dd/yyyy',
  ShortDateEU = 'dd/MM/yyyy',
  MediumDate = 'MMM dd, yyyy',
  LongDate = 'MMMM dd, yyyy',
  FullDate = 'EEEE MMM dd, yyyy',
}

export type EventChangeEventType = 'start' | 'end' | 'both';

export interface EventChangeEventBase {
  changeType: EventChangeEventType;
  delta: { h: number; m: number };
}

export interface EventChangeEvent extends EventChangeEventBase {
  event: CalendarEvent;
}
